<div fxLayout="row wrap" class="summary" @fadeIn>
  <div fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" *ngIf="config.editOption">
          <h3>{{config.title}}</h3>
          <mat-icon *ngIf="!isEdit" (click)="onEdit()" class="pointer">edit</mat-icon>
          <mat-icon *ngIf="isEdit" (click)="onEdit()" class="pointer">close</mat-icon>
        </div>
        <form (ngSubmit)="onFormSubmit()" [formGroup]="patientForm">
          <div fxLayout="row warp" fxLayoutAlign="space-between start">
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="First Name" formControlName="fname" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Last Name" formControlName="lname" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput [placeholder]="placeholders.email" formControlName="email" [readonly]="!isEdit">
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row warp" fxLayoutAlign="space-between start">
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <mat-label>Date of Birth</mat-label>
                <input matInput [matDatepicker]="dob" formControlName="birthDate" [readonly]="!isEdit">
                <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                <mat-datepicker #dob [disabled]="!isEdit"></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput [placeholder]="placeholders.phone" formControlName="phone" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Medical Record Number" formControlName="mrn" [readonly]="!isEdit">
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row warp" fxLayoutAlign="space-between start">
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Address line 1" formControlName="addrLine1" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Address line 2" formControlName="addrLine2" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="City" formControlName="city" [readonly]="!isEdit">
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row warp" fxLayoutAlign="space-between start">
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="State" formControlName="state" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Zip code" formControlName="postalCode" [readonly]="!isEdit">
              </mat-form-field>
            </div>
            <div fxFlex.gt-sm="30" fxFlex="100"></div>
          </div>
          <div fxLayout="row warp" *ngIf="isEdit">
            <button mat-raised-button type="submit" color="primary" class="m-r-20">{{config.primaryBtnText}}</button>
            <button mat-raised-button color="secondary" (click)="onEdit()">{{config.secondaryBtnText}}</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>